// Experience Pingingo ================================================================================================

// Section 1 ----------------------------------
window.KelolaOTAHeaderTxtid = "Kelola OTA <span className='SmallTextPadding BasicRadius' style={{whiteSpace:'nowrap', backgroundColor:'#ED7C42', color:'white'}}>#Tanpa Ribet</span>";
window.KelolaOTAHeaderTxten = "Manage OTAs <span className='SmallTextPadding BasicRadius' style={{whiteSpace:'nowrap', backgroundColor:'#ED7C42', color:'white'}}>#Without Hassle</span>";

window.BookingTetapJalanHeaderTxtid = "Booking Tetap Jalan.";
window.BookingTetapJalanHeaderTxten = "Bookings are still ongoing.";

window.ExperienceSection1MessageTxtid = "PinginGo membantu penginapan nature & experience stay mengelola OTA secara rapi, konsisten, dan profesional tanpa membebani operasional harian Anda.";
window.ExperienceSection1MessageTxten = "PinginGo helps nature & experience stays manage OTAs neatly, consistently, and professionally without burdening your daily operations.";

window.Free15MinutesBtnTxtid = "Audit Properti Gratis Selama 15 Menit";
window.Free15MinutesBtnTxten = "Free 15-Minute Property Audit";

window.DownloadOurProposalBtnTxtid = "Unduh Proposal Kami";
window.DownloadOurProposalBtnTxten = "Download Our Proposal";


// Section 2 ----------------------------------
window.SiapaHeaderTxtid = "Siapa";
window.SiapaHeaderTxten = "Who is";

window.ExperienceSectioneMessage1Txtid = "PinginGo adalah platform perjalanan berbasis alam dan pengalaman yang menggabungkan aplikasi booking terkurasi dengan layanan manajemen OTA profesional untuk membantu penginapan unik bertumbuh secara berkelanjutan.";
window.ExperienceSectioneMessage1Txten = "PinginGo is a nature-based and experience-based travel platform that combines a curated booking app with professional OTA management services to help unique lodgings grow sustainably.";

window.ExperienceSectioneMessage2Txtid = "Melalui aplikasi PinginGo, kami menghubungkan wisatawan dengan penginapan dan pengalaman terkurasi di seluruh Indonesia. Kami juga mendukung pemilik akomodasi melalui layanan setup dan manajemen OTA profesional membantu penginapan untuk listing, optimasi, dan pengelolaan di berbagai kanal OTA utama.";
window.ExperienceSectioneMessage2Txten = "Through the PinginGo app, we connect travelers with curated accommodations and experiences across Indonesia. We also support accommodation owners with professional OTA setup and management services, helping accommodations with listings, optimization, and management across major OTA channels.";


// Section 3 ----------------------------------
window.ExperienceSectionHeader3Txtid = "Masalah yang Sering Dialami Penginapan";
window.ExperienceSectionHeader3Txten = "Common Problems Experienced by Accommodation";

window.ExperienceMasalah1Txtid = "Ribet dan Memakan Waktu";
window.ExperienceMasalah1Txten = "Complicated and Time-Consuming";

window.ExperienceMasalah2Txtid = "Transparansi harga yang didapat";
window.ExperienceMasalah2Txten = "Price transparency obtained";

window.ExperienceMasalah3Txtid = "Sudah Listing, tapi Sepi Booking";
window.ExperienceMasalah3Txten = "Already Listed, but Quiet Bookings";

window.ExperienceMasalah4Txtid = "Kurang Paham Setup OTA";
window.ExperienceMasalah4Txten = "Not sure about OTA setup";

window.ExperienceMasalah5Txtid = "Tidak Memiliki Manpower Khusus";
window.ExperienceMasalah5Txten = "Doesn't Have Special Manpower";

window.ExperienceMasalah6Txtid = "Mindset Harga Dikontrol OTA";
window.ExperienceMasalah6Txten = "OTA Controlled Price Mindset";

window.ExperienceMasalah7Txtid = "Kurangnya Awareness & Visibilitas";
window.ExperienceMasalah7Txten = "Lack of Awareness & Visibility";

window.ExperienceMasalah8Txtid = "Komisi OTA yang Tinggi";
window.ExperienceMasalah8Txten = "High OTA Commissions";


// Section 4 ----------------------------------
window.ExperienceSectionHeader4Txtid = "Solusi dari";
window.ExperienceSectionHeader4Txten = "The solution of";

window.ExperienceSolusiHeader1Txtid = "Setup & Aktivasi OTA";
window.ExperienceSolusiHeader1Txten = "OTA Setup & Activation";
window.ExperienceSolusiMessage1Txtid = "Pembuatan dan pengaturan akun OTA hingga properti siap menerima booking.";
window.ExperienceSolusiMessage1Txten = "OTA account creation and setup until the property is ready to accept bookings.";

window.ExperienceSolusiHeader2Txtid = "Optimasi Listing";
window.ExperienceSolusiHeader2Txten = "Listing Optimization";
window.ExperienceSolusiMessage2Txtid = "Judul, deskripsi, dan highlight berbasis storytelling agar listing lebih menarik dan mudah ditemukan.";
window.ExperienceSolusiMessage2Txten = "Storytelling-based titles, descriptions, and highlights to make listings more engaging and easier to find.";

window.ExperienceSolusiHeader3Txtid = "Penataan Visual & Konten";
window.ExperienceSolusiHeader3Txten = "Visual & Content Arrangement";
window.ExperienceSolusiMessage3Txtid = "Judul, deskripsi, dan highlight berbasis storytelling agar listing lebih menarik dan mudah ditemukan.";
window.ExperienceSolusiMessage3Txten = "Storytelling-based titles, descriptions, and highlights to make listings more engaging and easier to find.";

window.ExperienceSolusiHeader4Txtid = "Strategi Harga";
window.ExperienceSolusiHeader4Txten = "Pricing Strategy";
window.ExperienceSolusiMessage4Txtid = "Penentuan harga yang sehat berdasarkan hari, musim, dan demand tanpa banting harga.";
window.ExperienceSolusiMessage4Txten = "Healthy pricing based on day, season, and demand without price gouging.";

window.ExperienceSolusiHeader5Txtid = "Manajemen Kalender & Ketersediaan";
window.ExperienceSolusiHeader5Txten = "Calendar Management & Availability";
window.ExperienceSolusiMessage5Txtid = "Sinkronisasi kalender untuk mencegah overbooking dan kesalahan tanggal.";
window.ExperienceSolusiMessage5Txten = "Calendar synchronization to prevent overbooking and date errors.";

window.ExperienceSolusiHeader6Txtid = "Monitoring & Optimasi Berkala";
window.ExperienceSolusiHeader6Txten = "Periodic Monitoring & Optimization";
window.ExperienceSolusiMessage6Txtid = "Sinkronisasi kalender untuk mencegah overbooking dan kesalahan tanggal.";
window.ExperienceSolusiMessage6Txten = "Calendar synchronization to prevent overbooking and date errors.";

window.ExperienceSolusiHeader7Txtid = "Express Website untuk Properti anda";
window.ExperienceSolusiHeader7Txten = "Express Website for your Property";
window.ExperienceSolusiMessage7Txtid = "Monitoring performa listing dan penyesuaian berkala untuk hasil yang lebih stabil.";
window.ExperienceSolusiMessage7Txten = "Monitoring of listing performance and periodic adjustments for more stable results.";


// Section 5 ----------------------------------
window.ExperienceSection5HeaderTxtid = "Kenapa Memilih <span style={{color:'#ED7C42'}}>PinginGo?</span>";
window.ExperienceSection5HeaderTxten = "Why Choose <span style={{color:'#ED7C42'}}>PinginGo?</span>";

window.ExperienceSection5ReasonHeader1Txtid = "Spesialis Penginapan Nature & Experience";
window.ExperienceSection5ReasonHeader1Txten = "Nature & Experience Accommodation Specialist";
window.ExperienceSection5ReasonMessage1Txtid = "Kami paham cara menjual penginapan unik villa, glamping, eco-lodge, dan boutique stay tanpa menjadikannya hotel massal.";
window.ExperienceSection5ReasonMessage1Txten = "We understand how to sell unique villas, glamping, eco-lodges, and boutique stays without turning them into mass hotels.";

window.ExperienceSection5ReasonHeader2Txtid = "Menjual Nilai, Bukan Diskon";
window.ExperienceSection5ReasonHeader2Txten = "Selling Value, Not Discounts";
window.ExperienceSection5ReasonMessage2Txtid = "Pendekatan kami berbasis storytelling, positioning, dan pengalaman, sehingga booking tidak bergantung pada diskon terus-menerus.";
window.ExperienceSection5ReasonMessage2Txten = "Our approach is based on storytelling, positioning, and experience, so bookings don't depend on constant discounts.";

window.ExperienceSection5ReasonHeader3Txtid = "Lebih dari Sekadar Admin OTA";
window.ExperienceSection5ReasonHeader3Txten = "More Than Just an OTA Admin";
window.ExperienceSection5ReasonMessage3Txtid = "Kami tidak hanya mengunggah kamar, tetapi merancang listing yang menarik tamu yang tepat dan meningkatkan konversi.";
window.ExperienceSection5ReasonMessage3Txten = "We don't just upload rooms, but design listings that attract the right guests and increase conversions.";

window.ExperienceSection5ReasonHeader4Txtid = "Berpihak pada Owner & Transparan";
window.ExperienceSection5ReasonHeader4Txten = "Owner-Supporting & Transparent";
window.ExperienceSection5ReasonMessage4Txtid = "Akun, data, dan keputusan harga tetap sepenuhnya milik pemilik penginapan. Tanpa lock-in, tanpa kontrol tersembunyi.";
window.ExperienceSection5ReasonMessage4Txten = "Accounts, data, and pricing decisions remain entirely the property of the innkeeper. No lock-ins, no hidden controls.";

window.ExperienceSection5ReasonHeader5Txtid = "Lebih Tenang, Lebih Terkontrol";
window.ExperienceSection5ReasonHeader5Txten = "Calmer, More Controlled";
window.ExperienceSection5ReasonMessage5Txtid = "Dari sinkronisasi kalender hingga monitoring rutin, kami meminimalkan kesalahan, risiko overbooking, dan kerumitan operasional.";
window.ExperienceSection5ReasonMessage5Txten = "From calendar synchronization to routine monitoring, we minimize errors, overbooking risks, and operational complexity.";

window.ExperienceSection5ReasonHeader6Txtid = "Didukung Ekosistem PinginGo";
window.ExperienceSection5ReasonHeader6Txten = "Supported by PinginGo Ecosystem";
window.ExperienceSection5ReasonMessage6Txtid = "Selain manajemen OTA, penginapan Anda mendapat exposure dari platform travel PinginGo yang berfokus pada nature, insight pasar, dan dukungan konten.";
window.ExperienceSection5ReasonMessage6Txten = "In addition to OTA management, your accommodation gets exposure from PinginGo's travel platform, which focuses on nature, market insights, and content support.";


// Section 6 ----------------------------------
window.ExperienceSection6HeaderTxtid = "Alur Kerja yang Terstruktur";
window.ExperienceSection6HeaderTxten = "Structured Workflow";

window.ExperienceDaftarHeaderTxt1id = "Audit & Onboarding";
window.ExperienceDaftarHeaderTxt1en = "Audit & Onboarding";
window.ExperienceDaftarMessageTxt1id = "Kami meninjau penginapan dan mengumpulkan seluruh aset yang dibutuhkan.";
window.ExperienceDaftarMessageTxt1en = "We review the accommodation and gather all the necessary assets.";

window.ExperienceDaftarHeaderTxt2id = "Pengaturan & Optimasi";
window.ExperienceDaftarHeaderTxt2en = "Setup & Optimization";
window.ExperienceDaftarMessageTxt2id = "Kami menyiapkan akun OTA serta mengoptimalkan listing, konten, dan harga.";
window.ExperienceDaftarMessageTxt2en = "We set up OTA accounts and optimize listings, content, and pricing.";

window.ExperienceDaftarHeaderTxt3id = "Go Live";
window.ExperienceDaftarHeaderTxt3en = "Go Live";
window.ExperienceDaftarMessageTxt3id = "Penginapan tayang dan siap menerima booking.";
window.ExperienceDaftarMessageTxt3en = "The accommodation is live and ready to accept bookings.";

window.ExperienceDaftarHeaderTxt4id = "Monitor & Improve";
window.ExperienceDaftarHeaderTxt4en = "Monitor & Improve";
window.ExperienceDaftarMessageTxt4id = "Performa dipantau dan dioptimalkan secara berkala.";
window.ExperienceDaftarMessageTxt4en = "Performance is monitored and optimized regularly.";


// Section 7 ----------------------------------
window.ExperienceSection7HeaderTxtid = "Hasil yang Diharapkan<br/><span className='BiggerSizeText PoppinsBoldTextFont' style={{color:'#ED7C42'}}></span>";
window.ExperienceSection7HeaderTxten = "Expected Results<br/><span className='BiggerSizeText PoppinsBoldTextFont' style={{color:'#ED7C42'}}></span>";

window.ExperienceSection7Message1Txtid = "Listing Profesional & Siap Konversi";
window.ExperienceSection7Message1Txten = "Professional & Conversion Ready Listings";
window.ExperienceSection7Message2Txtid = "Penginapan tampil rapi, konsisten, dan menarik di OTA memudahkan calon tamu memahami value penginapan dan melakukan booking.";
window.ExperienceSection7Message2Txten = "A clean, consistent, and attractive appearance on OTAs makes it easier for potential guests to understand the value of the accommodation and make a booking.";

window.HasilDiharapkanHeaderTxt1id = "Positioning Kuat Tanpa Perang Harga";
window.HasilDiharapkanHeaderTxt1en = "Strong Positioning Without Price Wars";
window.HasilDiharapkanMessageTxt1id = "Kami menonjolkan pengalaman dan karakter penginapan, sehingga Anda tidak bergantung pada diskon terus-menerus untuk bersaing.";
window.HasilDiharapkanMessageTxt1en = "We highlight the experience and character of the accommodation, so you don't have to rely on constant discounts to compete.";

window.HasilDiharapkanHeaderTxt2id = "Visibilitas Lebih Baik di OTA";
window.HasilDiharapkanHeaderTxt2en = "Better Visibility on OTA";
window.HasilDiharapkanMessageTxt2id = "Struktur listing, konten, dan kategori yang tepat membantu penginapan lebih mudah muncul di pencarian yang relevan.";
window.HasilDiharapkanMessageTxt2en = "Proper listing structure, content, and categories help your property appear more easily in relevant searches.";

window.HasilDiharapkanHeaderTxt3id = "Kontrol Harga & Ketersediaan Lebih Sehat";
window.HasilDiharapkanHeaderTxt3en = "Healthier Price Control and Availability";
window.HasilDiharapkanMessageTxt3id = "Strategi harga weekday, weekend, dan seasonal lebih terarah, dengan kalender tersinkron untuk meminimalkan risiko overbooking.";
window.HasilDiharapkanMessageTxt3en = "More targeted weekday, weekend, and seasonal pricing strategies, with synchronized calendars to minimize the risk of overbooking.";

window.HasilDiharapkanHeaderTxt4id = "Beban Operasional Lebih Ringan";
window.HasilDiharapkanHeaderTxt4en = "Lighter Operational Burden";
window.HasilDiharapkanMessageTxt4id = "Pekerjaan admin OTA berkurang, kesalahan manual diminimalkan, dan pengelolaan jadi lebih terstruktur.";
window.HasilDiharapkanMessageTxt4en = "OTA admin work is reduced, manual errors are minimized, and management becomes more structured.";

window.HasilDiharapkanHeaderTxt5id = "Insight untuk Pengambilan Keputusan";
window.HasilDiharapkanHeaderTxt5en = "Insights for Decision Making";
window.HasilDiharapkanMessageTxt5id = "Monitoring performa memberikan gambaran yang jelas terkait permintaan, harga, dan performa listing untuk keputusan yang lebih tepat.";
window.HasilDiharapkanMessageTxt5en = "Performance monitoring provides a clear picture of demand, pricing, and listing performance for more informed decisions.";


// Section 8 ----------------------------------
window.ExperienceSection8HeaderTxtid = "Paket Layanan";
window.ExperienceSection8HeaderTxten = "Service Package";

window.ExperienceSection8MessageTxtid = "Kami membantu memasarkan penginapan Anda melalui berbagai saluran, dari media sosial hingga website. Dengan strategi komprehensif, visibilitas meningkat dan tamu lebih banyak! 📈🏨";
window.ExperienceSection8MessageTxten = "We help market your accommodation through various channels, from social media to your website. With a comprehensive strategy, you'll increase visibility and attract more guests! 📈🏨";

window.TagTerimaBeresTxtid = "#TERIMABERES";
window.TagTerimaBeresTxten = "#TERIMABERES";

window.PaketLayanan1Txtid = "Manajemen penuh multi OTA";
window.PaketLayanan1Txten = "Full multi OTA management";

window.PaketLayanan2Txtid = "Sinkronisasi kalender";
window.PaketLayanan2Txten = "Calendar sync";

window.PaketLayanan3Txtid = "Optimasi konten berbasis storytelling";
window.PaketLayanan3Txten = "Storytelling-based content optimization";

window.PaketLayanan4Txtid = "Monitoring & optimasi 1 bulan";
window.PaketLayanan4Txten = "Monitoring & optimization 1 month";

window.PaketLayanan5Txtid = "Strategi harga weekday & weekend";
window.PaketLayanan5Txten = "Weekday & weekend pricing strategy";

window.PaketLayanan6Txtid = "Earning Calculator";
window.PaketLayanan6Txten = "Earning Calculator";

window.PaketLayanan7Txtid = "Minim risiko overbooking";
window.PaketLayanan7Txten = "Minimize the risk of overbooking";

window.PaketLayanan8Txtid = "Laporan & insight berkala";
window.PaketLayanan8Txten = "Periodic reports & insights";

window.GratisBiayaSetupHeaderTxtid = "GRATIS BIAYA SETUP!";
window.GratisBiayaSetupHeaderTxten = "FREE SETUP FEE!";

window.GratisBiayaSetupMessageTxtid = "Biaya layanan <span className='PoppinsBoldTextFont'>2,5%</span> per transaksi di seluruh OTA dengan minimal kontrak 1 tahun bersama PinginGo.";
window.GratisBiayaSetupMessageTxten = "Service fee <span className='PoppinsBoldTextFont'>2.5%</span> per transaction across all OTAs with a minimum 1-year contract with PinginGo.";


// Section 8B ----------------------------------
window.AddOnsHeaderTxtid = "Add-Ons";
window.AddOnsHeaderTxten = "Add-Ons";

window.ExperienceSection8BHeaderTxtid = "Website Property Express";
window.ExperienceSection8BHeaderTxten = "Website Property Express";

window.ExperienceAddOns1Txtid = "Website properti kustom menggunakan 5 template yang clean & elegan";
window.ExperienceAddOns1Txten = "Costume property website using 5 clean and elegant templates";

window.ExperienceAddOns2Txtid = "Halaman informasi properti (kamar, fasilitas, lokasi, galeri)";
window.ExperienceAddOns2Txten = "Property information page (rooms, facilities, location, gallery)";

window.ExperienceAddOns3Txtid = "Desain mobile-friendly & responsif";
window.ExperienceAddOns3Txten = "Mobile-friendly and responsive design";

window.ExperienceAddOns4Txtid = "Integrasi direct booking";
window.ExperienceAddOns4Txten = "Direct booking integration";

window.ExperienceAddOns5Txtid = "Struktur dasar SEO-ready";
window.ExperienceAddOns5Txten = "SEO-ready basic structure";


// Section 9 ----------------------------------
window.ExperienceSection9HeaderTxtid = "Siap meningkatkan performa listing Anda?";
window.ExperienceSection9HeaderTxten = "Ready to improve your listing performance?";

window.JadwalkanAuditBtnMobileTxtid = "Jadwalkan Audit";
window.JadwalkanAuditBtnMobileTxten = "Schedule an Audit";

window.JadwalkanAuditBtnTxtid = "Jadwalkan Audit Gratis 15 Menit Sekarang";
window.JadwalkanAuditBtnTxten = "Schedule a Free 15 Minute Audit Now";





// Listing Mitra ================================================================================================

window.AccommodationTypeListingTxt =
[
    {
        "type_name":
        {
            "id":"Glamping",
            "en":"Glamping",
        },
        "type_selected":"Glamping",
        "image_url":"/Assets/images/ExtraPage/MitraTypeChoiceImage/Glamping.png",
        "image_url_big":"/Assets/images/ExtraPage/ListingMitra/accomodation-type1.svg",
        "description":
        {
            "id":"Glamping (glamorous camping) adalah camping nyaman dengan fasilitas mewah, tanpa repot bawa tenda! ⛺✨",
            "en":"Glamping (glamorous camping) is comfortable camping with luxurious facilities, without the hassle of bringing a tent! ⛺✨"
        }
    },
    {
        "type_name":
        {
            "id":"Camp Ground",
            "en":"Camp Ground",
        },
        "type_selected":"Camp Ground",
        "image_url":"/Assets/images/ExtraPage/MitraTypeChoiceImage/Camp_Ground.png",
        "image_url_big":"/Assets/images/ExtraPage/ListingMitra/accomodation-type2.svg",
        "description":
        {
            "id":"Camp ground menyediakan area camping yang bisa disewa untuk pengalaman berkemah yang seru dan nyaman.",
            "en":"The camp ground provides camping areas that can be rented for a fun and comfortable camping experience."
        }
    },
    {
        "type_name":
        {
            "id":"Resort",
            "en":"Resort",
        },
        "type_selected":"Ressort",
        "image_url":"/Assets/images/ExtraPage/MitraTypeChoiceImage/Ressort.png",
        "image_url_big":"/Assets/images/ExtraPage/ListingMitra/accomodation-type3.svg",
        "description":
        {
            "id":"PinginGo Resort menyewakan penginapan eksklusif di alam dengan fasilitas lengkap untuk liburan nyaman dan berkesan! 🌿🏡✨",
            "en":"PinginGo Resort offers exclusive accommodations in the heart of nature with complete amenities for a comfortable and memorable vacation! 🌿🏡✨"
        }
    },
    {
        "type_name":
        {
            "id":"Villa",
            "en":"Villa",
        },
        "type_selected":"Villa",
        "image_url":"/Assets/images/ExtraPage/MitraTypeChoiceImage/Villa.png",
        "image_url_big":"/Assets/images/ExtraPage/ListingMitra/accomodation-type4.svg",
        "description":
        {
            "id":"PinginGo Villa menyewakan villa eksklusif dengan suasana alam dan fasilitas lengkap untuk liburan nyaman dan private! 🌿🏡✨",
            "en":"PinginGo Villa rents exclusive villas with natural surroundings and complete facilities for a comfortable and private vacation! 🌿🏡✨"
        }
    },
    {
        "type_name":
        {
            "id":"Hotels",
            "en":"Hotels",
        },
        "type_selected":"Hotels",
        "image_url":"/Assets/images/ExtraPage/MitraTypeChoiceImage/Hotels.png",
        "image_url_big":"/Assets/images/ExtraPage/ListingMitra/accomodation-type5.svg",
        "description":
        {
            "id":"PinginGo Hotel menyewakan kamar hotel nyaman dengan fasilitas lengkap, cocok untuk liburan atau perjalanan bisnis! 🏨✨",
            "en":"PinginGo Hotel rents comfortable hotel rooms with complete facilities, perfect for vacations or business trips! 🏨✨"
        }
    },
    {
        "type_name":
        {
            "id":"Cabin",
            "en":"Cabin",
        },
        "type_selected":"",
        "image_url":"/Assets/images/ExtraPage/MitraTypeChoiceImage/Cabin.png",
        "image_url_big":"/Assets/images/ExtraPage/ListingMitra/accomodation-type6.svg",
        "description":
        {
            "id":"PinginGo Cabin menyewakan kabin nyaman di tengah alam, cocok untuk liburan tenang dengan suasana hangat dan fasilitas lengkap! 🌲🏡✨",
            "en":"PinginGo Cabin rents out cozy cabins amidst nature, perfect for a quiet getaway with a warm atmosphere and complete amenities! 🌲🏡✨"
        }
    }
]

window.OthersTypeChoiceTxtid = "Jenis Lainnya";
window.OthersTypeChoiceTxten = "Others Type";

window.HelloMitraPinginGoTxtid = "Halo, Mitra PinginGo!";
window.HelloMitraPinginGoTxten = "Hello, Mitra PinginGo!";

// Header List -------------------------------------------------------------------

window.BermitraTopMessageTxt1id = "Beri tahu kami jenis akomodasi Anda";
window.BermitraTopMessageTxt1en = "Tell us your accommodation type";

window.BermitraTopMessageTxt2id = "Beri tahu kami nama akomodasi Anda";
window.BermitraTopMessageTxt2en = "Tell us your accommodation name";

window.BermitraTopMessageTxt3id = "Lokasi akomodasi Anda";
window.BermitraTopMessageTxt3en = "Your accommodation location";

window.BermitraTopMessageTxt4id = "Tunjukkan foto dan media sosial akomodasi Anda";
window.BermitraTopMessageTxt4en = "Show us your accommodation photos and social media";

window.BermitraTopMessageTxt5id = "Beri tahu kami jumlah kamar dan tarifnya";
window.BermitraTopMessageTxt5en = "Tell us your total rooms and rates";

window.BermitraTopMessageTxt6id = "Profil Anda";
window.BermitraTopMessageTxt6en = "Your Profile";


// Section 1 -----------------------

window.Section1HeaderListTxtid = "Daftarkan";
window.Section1HeaderListTxten = "List Your";

window.Section1HeaderAccommodationTxtid = "Akomodasi Anda";
window.Section1HeaderAccommodationTxten = "Accommodation";

window.Section1HeaderOnPinginGoTxtid = "di <span class=\"SmallTextPadding BasicRadius\" style=\"white-space: nowrap; background-color: rgb(36, 148, 217); color: white;\">PinginGo</span>"
window.Section1HeaderOnPinginGoTxten = "on <span class=\"SmallTextPadding BasicRadius\" style=\"white-space: nowrap; background-color: rgb(36, 148, 217); color: white;\">PinginGo</span>";

window.TopMessageListingMitraTxtid = "Dan Tampilkan Keindahan Alam dari Penginapan Anda: Raih Kesempatan Terbaik sebagai Hidden Gem atau Glamping, Villa, Resort yang Menawarkan Pengalaman Menginap Tak Terlupakan bagi Para Pengunjung.";
window.TopMessageListingMitraTxten = "And Showcase the Natural Beauty of Your Accommodation: Grab the Best Opportunity as a Hidden Gem or Glamping, Villa, Resort that Offers an Unforgettable Stay Experience for Visitors.";

// Section 2 -----------------------

window.TentangTxtid = "Tentang";
window.TentangTxten = "About";

window.Message1Section2Txtid = "Sebagai Online Platform yang berfokus memasarkan dan mempromosikan akomodasi yang bertema <span class='PoppinsBoldTextFont'>“Beauty of Nature”</span> dan <span class='PoppinsBoldTextFont'>“Unique Accomodation”</span> dengan menggunakan <span class='PoppinsBoldTextFont'>Program Terbaik PinginGo</span>.";
window.Message1Section2Txten = "As an online platform focused on marketing and promoting accommodations with the themes of <span class='PoppinsBoldTextFont'>“Beauty of Nature”</span> and <span class='PoppinsBoldTextFont'>“Unique Accommodation”</span> through the use of <span class='PoppinsBoldTextFont'>PinginGo’s Best Program</span>.";

window.Message2Section2Txtid = "PinginGo membantu para pecinta perjalanan dari anak muda hingga dewasa menemukan penginapan bertema Beauty of Nature, Unique Accommodation, dan Hidden Gem di seluruh Indonesia. Seiring tren staycation yang semakin diminati, kami hadir untuk mempermudah pencarian akomodasi yang memikat dan tak terlupakan.";
window.Message2Section2Txten = "PinginGo helps travel enthusiasts, from young to old, find accommodations themed Beauty of Nature, Unique Accommodations, and Hidden Gems throughout Indonesia. As the staycation trend continues to grow, we're here to make it easier to find captivating and unforgettable accommodations.";

// Section 3 -----------------------

window.ChooseTxtid = "Memilih";
window.ChooseTxten = "Choose";

window.BecomeYourPartnerTxtid = "Menjadi Partner Anda";
window.BecomeYourPartnerTxten = "as your partner";

window.ReasonHeader1Section3Txtid = "Pendaftaran Yang Mudah";
window.ReasonHeader1Section3Txten = "Easy Registration";
window.ReasonMessage1Section3Txtid = "Kenyamanan saat mendaftar adalah prioritas kami, daftar secara mudah dan cepat dan di bantu oleh Customer Service PinginGo.";
window.ReasonMessage1Section3Txten = "Your convenience during registration is our priority, register easily and quickly and be assisted by PinginGo Customer Service.";

window.ReasonHeader2Section3Txtid = "Pemasaran yang luas";
window.ReasonHeader2Section3Txten = "Extensive marketing";
window.ReasonMessage2Section3Txtid = "Bergabung dengan PinginGo berarti penginapan Anda mendapat dukungan promo dan pemasaran, meningkatkan visibilitas dan reservasi! 🚀✨";
window.ReasonMessage2Section3Txten = "Joining PinginGo means your accommodation gets promotional and marketing support, increasing visibility and bookings! 🚀✨";

window.ReasonHeader3Section3Txtid = "Layanan Bantuan 24 Jam";
window.ReasonHeader3Section3Txten = "24 Hours Support Service";
window.ReasonMessage3Section3Txtid = "PinginGo menyediakan layanan bantuan 24/7, memastikan Anda selalu mendapat dukungan kapan pun dibutuhkan! 🕒📞✨";
window.ReasonMessage3Section3Txten = "PinginGo provides 24/7 support, ensuring you always have support whenever you need it! 🕒📞✨";

window.ReasonHeader4Section3Txtid = "Kemudahan Kelola Akomodasi";
window.ReasonHeader4Section3Txten = "Easy Accommodation Management";
window.ReasonMessage4Section3Txtid = "Mitra dapat dengan mudah mengatur harga dan ketersediaan kamar, menyesuaikan permintaan pelanggan, serta mengoptimalkan pendapatan dan promosi. Fleksibilitas ini membuat pengelolaan penginapan lebih efisien dan responsif! 💼🏨✨";
window.ReasonMessage4Section3Txten = "Partners can easily manage room rates and availability, adapt to customer demand, and optimize revenue and promotions. This flexibility makes lodging management more efficient and responsive! 💼🏨✨";

window.ReasonHeader5Section3Txtid = "Transaksi Aman";
window.ReasonHeader5Section3Txten = "Safe Transactions";
window.ReasonMessage5Section3Txtid = "Sistem transaksi kami yang aman dan tepercaya memastikan mitra bisa fokus menjalankan bisnis tanpa khawatir. Keamanan dan kenyamanan Anda adalah prioritas kami! 🔒💳😊";
window.ReasonMessage5Section3Txten = "Our secure and trusted transaction system ensures partners can focus on running their businesses without worry. Your safety and comfort are our priority! 🔒💳😊";


// Section 4 -----------------------

window.Section4HeaderTxtid = "Jelajahi Keajaiban Alam dengan Penginapan Indah PinginGo";
window.Section4HeaderTxten = "Explore Natural Wonders with PinginGo's Beautiful Accommodation";

window.Section4MessageTxtid = "Kami menerima berbagai jenis akomodasi seperti Glamping, Camp Ground, Resort, Villa, Hotel, dan lainnya. 🌟🏕️🏡";
window.Section4MessageTxten = "We accept various types of accommodations such as glamping, camping, resorts, villas, hotels, and more. 🌟🏕️🏡";

// Section 5 -----------------------

window.Section5HeaderTxtid = "Dukungan perbankan untuk renovasi.";
window.Section5HeaderTxten = "Banking support for renovation.";

window.Section5MessageTxtid = "Kerjasama antara Pingingo dan lembaga perbankan untuk mendukung pembiayaan renovasi hotel adalah inisiatif strategis yang dapat memberikan manfaat yang signifikan bagi semua pihak yang terlibat. Renovasi hotel merupakan langkah penting untuk meningkatkan kualitas pelayanan, menarik lebih banyak tamu, dan memastikan hotel tetap kompetitif dalam industri perhotelan yang kompetitif.";
window.Section5MessageTxten = "The collaboration between Pingingo and banking institutions to support hotel renovation financing is a strategic initiative that can provide significant benefits for all parties involved. Hotel renovation is a crucial step to improve service quality, attract more guests, and ensure the hotel remains competitive in the competitive hospitality industry.";

// Section 6 -----------------------

window.Section6HeaderTxtid = "Program dan Fitur Kami";
window.Section6HeaderTxten = "Our Program & Features";

window.OurProgram1HeaderTxtid = "Referral<br>Rewards";
window.OurProgram1HeaderTxten = "Referral<br>Rewards";
window.OurProgram1MessageTxtid = "Program utama dari PinginGo yang akan membantu meningkatkan awareness dan visibilitas Anda! Ketika para pengguna membagikan dan melakukan booking di penginapan Anda, mereka akan mendapatkan poin yang bisa ditukarkan dengan voucher, hadiah langsung, dan nginap gratis. Ini akan mendorong pengguna untuk berlomba-lomba membagikan penginapan Anda dan meningkatkan transaksi booking! 🚀🏨🎁";
window.OurProgram1MessageTxten = "PinginGo’s main program is designed to help boost your awareness and visibility! When users share and book a stay at your accommodation, they’ll earn points that can be redeemed for vouchers, instant prizes, and free stays. This encourages users to eagerly share your property and increase booking transactions! 🚀🏨🎁";

window.OurProgram2HeaderTxtid = "Nginep Gratis di PinginGo";
window.OurProgram2HeaderTxten = "Free Stay at PinginGO";
window.OurProgram2MessageTxtid = "Mau user bisa nginep gratis di penginapanmu? Gampang banget caranya! User tinggal share penginapan dan ajak teman serta keluarganya buat nginep di sana. Selain itu, user juga bisa dapetin poin yang bisa dituker dengan Voucher Nginap Gratis. Yuk, ajak lebih banyak orang dan nikmati keuntungannya! 🌟🏨✨";
window.OurProgram2MessageTxten = "Want users to stay at your accommodation for free? It's super easy! Simply share your accommodation and invite friends and family to stay there. Plus, users can earn points that can be redeemed for free stay vouchers. Invite more people and enjoy the benefits! 🌟🏨✨";

window.OurProgram3MessageTxtid = "User bisa mengajak sebanyak banyaknya teman atau keluarganya untuk mengikuti program Ajak Teman Double Cuan. Setiap user berhasil ajak teman untuk join di PinginGo, maka user bisa mendapatkan Poin yang bisa ditukarkan berbagai voucher menginap, menginap gratis dan hadiah langsung dari PinginGo";
window.OurProgram3MessageTxten = "Users can invite as many friends or family as they like to join the 'Invite a Friend Double Cuan' program. Every time a user successfully invites a friend to join PinginGo, they earn points that can be redeemed for various accommodation vouchers, free stays, and prizes directly from PinginGo.";

window.OurProgram4MessageTxtid = "PinginGo mempunyai fitur yang memberikan ruang bagi milenials membagi pengalaman melalui Ping EXPREZY dalam bentuk komen dan foto ala social media. Fitur ini membuat keunikan tempat penginapan Mitra tersebar dan menambah kuat brand mitra.";
window.OurProgram4MessageTxten = "PinginGo has a feature that allows millennials to share their experiences through Ping EXPREZY in the form of social media-style comments and photos. This feature helps spread the word about the uniqueness of Partners' accommodations and strengthens their brand.";

// Section 8 -----------------------

window.Section7HeaderTxtid = "Daftar Akomodasi Dengan Mudah";
window.Section7HeaderTxten = "Easily List Accommodations";

window.Section7Hint1HeaderTxtid = "Daftar Akomodasi";
window.Section7Hint1HeaderTxten = "Register Your Accommodation";
window.Section7Hint1MessageTxtid = "Isi form registrasi yang diberikan oleh CS PinginGo";
window.Section7Hint1MessageTxten = "Fill out the registration form provided by PinginGo’s Customer Service team.";

window.Section7Hint2HeaderTxtid = "Listing Akomodasimu";
window.Section7Hint2HeaderTxten = "List Your Accommodation";
window.Section7Hint2MessageTxtid = "Tambahkan informasi general, rooms dan upload gambar untuk akomodasimu di <span class='InterBoldTextFont'>Mitra PinginGo</span>";
window.Section7Hint2MessageTxten = "Add general information, room details, and upload photos of your accommodation on the <span class='InterBoldTextFont'>Mitra PinginGo Page</span>.";

window.Section7Hint3HeaderTxtid = "Atur Harga & Ketersedian Kamar";
window.Section7Hint3HeaderTxten = "Set Prices & Room Availability";
window.Section7Hint3MessageTxtid = "Atur harga dan ketersidaan kamar untuk akomodasi anda di <span class='InterBoldTextFont'>Mitra PinginGo</span>";
window.Section7Hint3MessageTxten = "Manage your accommodation’s pricing and room availability directly through the <span class='InterBoldTextFont'>Mitra PinginGo Page</span>.";

window.Section7Hint4HeaderTxtid = "Kamu Selesai!";
window.Section7Hint4HeaderTxten = "You’re All Set!";
window.Section7Hint4MessageTxtid = "CS akan verifikasi akomodasi kamu, akomodasi kamu akan segera live di PinginGo";
window.Section7Hint4MessageTxten = "Our Customer Service team will verify your accommodation, and once approved, your listing will go live on PinginGo.";

// Section 8 -----------------------

window.Section8HeaderTxtid = "Atur akomodasi anda dengan CMS Mitra";
window.Section8HeaderTxten = "Manage your accommodation with CMS Mitra";

window.Section8Hint1HeaderTxtid = "Satu Tools Untuk Semua Akomodasimu";
window.Section8Hint1HeaderTxten = "One Tool For All Your Accommodations";
window.Section8Hint1MessageTxtid = "CMS PinginGo Mitra adalah alat yang dirancang khusus untuk membantu Mitra PinginGo dalam mengelola akomodasi mereka, baik itu satu akomodasi (single) maupun beberapa akomodasi (multiple)";
window.Section8Hint1MessageTxten = "PinginGo Partner CMS is a tool specifically designed to help PinginGo Partners manage their accommodation, whether it is one accommodation (single) or several accommodations (multiple).";

window.Section8Hint2HeaderTxtid = "Mengatur harga dan ketersediaan secara fleksibel";
window.Section8Hint2HeaderTxten = "Set prices and availability flexibly";
window.Section8Hint2MessageTxtid = "Sesuaikan harga dan jadwal ketersediaan dengan fleksibel dalam hitungan menit. Pastikan akomodasi selalu siap menerima tamu dengan harga terbaik yang kompetitif.";
window.Section8Hint2MessageTxten = "Adjust your prices and availability flexibly in minutes. Ensure your accommodation is always ready to welcome guests at the best, most competitive rates.";

window.Section8Hint3HeaderTxtid = "Kelola allotment & diskon untuk menarik lebih banyak tamu";
window.Section8Hint3HeaderTxten = "Manage allotments & discounts to attract more guests";
window.Section8Hint3MessageTxtid = "Tentukan kuota kamar dan buat promo menarik untuk meningkatkan tingkat hunian. Strategi diskon yang tepat dapat membantu menarik lebih banyak tamu dan meningkatkan pendapatan.";
window.Section8Hint3MessageTxten = "Set room quotas and create attractive promotions to increase occupancy rates. The right discount strategy can help attract more guests and increase revenue.";

window.Section8Hint4HeaderTxtid = "Pantau performa akomodasi lewat dashboard informatif";
window.Section8Hint4HeaderTxten = "Monitor accommodation performance through an informative dashboard";
window.Section8Hint4MessageTxtid = "Dapatkan insight lengkap mengenai performa akomodasi melalui dashboard interaktif. Analisis tren pemesanan dan optimalkan strategi pemasaran untuk hasil yang lebih maksimal.";
window.Section8Hint4MessageTxten = "Gain comprehensive insights into your accommodation's performance through an interactive dashboard. Analyze booking trends and optimize your marketing strategy for maximum results.";

window.Section8Hint5HeaderTxtid = "Kelola pemesanan & transaksi dengan lebih mudah 🚀";
window.Section8Hint5HeaderTxten = "Manage orders and transactions more easily 🚀";
window.Section8Hint5MessageTxtid = "Semua pemesanan dan transaksi bisa dikelola dalam satu platform, dari konfirmasi booking hingga pembayaran. Proses lebih cepat, tamu lebih puas, dan operasional jadi lebih lancar! 🚀";
window.Section8Hint5MessageTxten = "All bookings and transactions can be managed within a single platform, from booking confirmation to payment. This results in faster processing, happier guests, and smoother operations! 🚀";

window.Section8Hint6HeaderTxtid = "Setup Akomodasi dengan Mudah";
window.Section8Hint6HeaderTxten = "Easy Accommodation Setup";
window.Section8Hint6MessageTxtid = "Tambahkan dan kelola akomodasi dalam beberapa langkah sederhana. Unggah foto, lengkapi detail fasilitas, dan atur harga tanpa ribet.";
window.Section8Hint6MessageTxten = "Add and manage accommodations in a few simple steps. Upload photos, complete facility details, and set prices without the hassle.";


// Section 8.5 -----------------------

window.Section85MessageTxtid = "🌿 Bergabunglah dengan PinginGo dan Jadilah Akomodasi Pilihan! ✨";
window.Section85MessageTxten = "🌿 Join PinginGo and Become a Top Accommodation Choice! ✨";

window.Section85DaftarkanButtonTxtid = "Daftarkan Akomodasimu di PinginGo";
window.Section85DaftarkanButtonTxten = "List Your Accommodation on PinginGo";

window.Section85DaftarkanButtonShortTxtid = "Daftarkan Akomodasimu";
window.Section85DaftarkanButtonShortTxten = "List Your Accommodation";

// Section 9 -----------------------

window.Section9HeaderTxtid = "PinginGo Channel Broadcast:";
window.Section9HeaderTxten = "PinginGo Channel Broadcast";

window.Section9MessageTxtid = "Kami membantu memasarkan penginapan Anda melalui berbagai saluran, mulai dari media sosial hingga website. Dengan strategi yang komprehensif, visibilitas meningkat dan jumlah tamu pun bertambah! 📈🏨";
window.Section9MessageTxten = "We help promote your accommodation across multiple channels — from social media to websites. With a comprehensive strategy, your visibility increases and more guests come your way! 📈🏨";

// Section 10 ------------------------

window.Section10InstagramBenefits1Txtid = "Maksimalkan pemasaran akomodasi Anda dengan fitur Channel Broadcast di Instagram!";
window.Section10InstagramBenefits1Txten = "Maximize your accommodation marketing with the Channel Broadcast feature on Instagram!";

window.Section10InstagramBenefits2Txtid = "✅ Update Promo & Diskon langsung ke audiens yang tertarget";
window.Section10InstagramBenefits2Txten = "✅ Update Promos & Discounts directly to the targeted audience";

window.Section10InstagramBenefits3Txtid = "✅ Informasi Real-Time tentang ketersediaan & penawaran eksklusif";
window.Section10InstagramBenefits3Txten = "✅ Real-Time information on availability & exclusive offers";

window.Section10InstagramBenefits4Txtid = "✅ Interaksi Lebih Dekat dengan calon tamu untuk meningkatkan booking";
window.Section10InstagramBenefits4Txten = "✅ Closer interaction with potential guests to increase bookings";

window.Section10InstagramBenefits5Txtid = "Jangkau lebih banyak pelanggan & tingkatkan visibilitas akomodasi Anda! 🚀";
window.Section10InstagramBenefits5Txten = "Reach more customers & increase your accommodation's visibility! 🚀";


window.Section10FacebookBenefits1Txtid = "Tingkatkan eksposur akomodasi Anda dengan Channel Broadcast di Facebook!";
window.Section10FacebookBenefits1Txten = "Boost your accommodation’s exposure with Channel Broadcast on Facebook!";

window.Section10FacebookBenefits2Txtid = "✅ Jangkauan Lebih Luas ke calon tamu potensial";
window.Section10FacebookBenefits2Txten = "✅ Reach a wider audience of potential guests";

window.Section10FacebookBenefits3Txtid = "✅ Update Promo & Ketersediaan secara real-time";
window.Section10FacebookBenefits3Txten = "✅ Share promotions & availability in real time";

window.Section10FacebookBenefits4Txtid = "✅ Interaksi Langsung melalui komentar & pesan";
window.Section10FacebookBenefits4Txten = "✅ Engage directly through comments & messages";

window.Section10FacebookBenefits5Txtid = "Optimalkan pemasaran dan tingkatkan booking dengan PinginGo!";
window.Section10FacebookBenefits5Txten = "Maximize your marketing and increase bookings with PinginGo!";


window.Section10TiktokBenefits1Txtid = "Promosikan akomodasi Anda dengan cara yang lebih fun & engaging di TikTok!";
window.Section10TiktokBenefits1Txten = "Promote your accommodation in a more fun and engaging way on TikTok!";

window.Section10TiktokBenefits2Txtid = "✅ Video Menarik untuk meningkatkan awareness & booking";
window.Section10TiktokBenefits2Txten = "✅ Interesting Videos to increase awareness & bookings";

window.Section10TiktokBenefits3Txtid = "✅ Tren & Challenge agar lebih viral di kalangan traveler";
window.Section10TiktokBenefits3Txten = "✅ Trends and Challenges to become more viral among travelers";

window.Section10TiktokBenefits4Txtid = "✅ Interaksi Langsung lewat live & komentar";
window.Section10TiktokBenefits4Txten = "✅ Direct interaction via live & comments";

window.Section10TiktokBenefits5Txtid = "Buat akomodasi Anda makin dikenal & dicari di TikTok! 🔥 #PinginGo";
window.Section10TiktokBenefits5Txten = "Make your accommodation more known and sought after on TikTok! 🔥 #PinginGo";


window.Section10BlogPinginGoBenefits1Txtid = "Blog PinginGo bukan sekadar artikel, tapi juga strategi pemasaran untuk meningkatkan visibilitas dan booking akomodasi Anda!";
window.Section10BlogPinginGoBenefits1Txten = "PinginGo Blog is not just articles, but also a marketing strategy to increase your visibility and accommodation bookings!";

window.Section10BlogPinginGoBenefits2Txtid = "✅ Eksposur Lebih Luas - Akomodasi Anda bisa masuk dalam artikel rekomendasi & panduan wisata.";
window.Section10BlogPinginGoBenefits2Txten = "✅ Wider Exposure - Your accommodation can be included in recommended articles & travel guides.";

window.Section10BlogPinginGoBenefits3Txtid = "✅ SEO & Traffic - Muncul di pencarian Google, menarik calon tamu yang mencari referensi perjalanan.";
window.Section10BlogPinginGoBenefits3Txten = "✅ SEO & Traffic - Appear in Google searches, attracting potential guests looking for travel references.";

window.Section10BlogPinginGoBenefits4Txtid = "✅ Konten Berkualitas - Dibuat dengan storytelling menarik agar lebih engaging & dipercaya traveler.";
window.Section10BlogPinginGoBenefits4Txten = "✅ Quality Content - Created with engaging storytelling to be more engaging & trusted by travelers.";

window.Section10BlogPinginGoBenefits5Txtid = "✅ Promosi Gratis - Liputan khusus tanpa biaya tambahan untuk meningkatkan awareness.";
window.Section10BlogPinginGoBenefits5Txten = "✅ Free Promotion - Special coverage at no additional cost to increase awareness.";


window.Section10CrowdSharingBenefits1Txtid = "Ping and Share membantu akomodasi Anda lebih dikenal & laris!";
window.Section10CrowdSharingBenefits1Txten = "Pink and Share helps your accommodation become more known and popular!";

window.Section10CrowdSharingBenefits2Txtid = "✅ Pemasaran Gratis - Dibagikan tanpa biaya tambahan.";
window.Section10CrowdSharingBenefits2Txten = "✅ Free Marketing - Shared at no additional cost.";

window.Section10CrowdSharingBenefits3Txtid = "✅ Jangkauan Luas - Tersebar di media sosial & komunitas traveler.";
window.Section10CrowdSharingBenefits3Txten = "✅ Wide Reach - Spread across social media and traveler communities.";

window.Section10CrowdSharingBenefits4Txtid = "✅ Lebih Banyak Booking - Semakin sering dibagikan, makin tinggi peluang pemesanan.";
window.Section10CrowdSharingBenefits4Txten = "✅ More Bookings - The more you share, the higher the chance of bookings.";

window.Section10CrowdSharingBenefits5Txtid = "✅ Efek Viral - Rekomendasi pengguna meningkatkan visibilitas.";
window.Section10CrowdSharingBenefits5Txten = "✅ Viral Effect - User recommendations increase visibility.";

window.Section10CrowdSharingBenefits6Txtid = "Promosi effortless, booking maksimal! 🔥🏡 #PinginGo";
window.Section10CrowdSharingBenefits6Txten = "Effortless promotion, maximum bookings! 🔥🏡 #PinginGo";


// Section 11 ------------------------

window.Section11Messsage1Txtid = "🌟 Ayo Gabung dengan PinginGo & Maksimalkan Booking Akomodasi Anda! 🚀";
window.Section11Messsage1Txten = "🌟 Join PinginGo & Maximize Your Accommodation Bookings! 🚀";

window.Section11Messsage2Txtid = "Daftar cepat tanpa biaya awal dan dapatkan eksposur lebih luas melalui berbagai saluran pemasaran. Atur harga, ketersediaan, dan pemesanan dalam satu dashboard yang praktis.";
window.Section11Messsage2Txten = "Sign up quickly with no initial fees and gain wider exposure through multiple marketing channels. Manage pricing, availability, and bookings in one convenient dashboard.";

window.Section11Messsage3Txtid = "🌿 Bergabunglah dengan PinginGo dan Jadilah Akomodasi Pilihan! ✨";
window.Section11Messsage3Txten = "🌿 Join PinginGo and Become the Accommodation of Choice! ✨";



// USER DATA RELATED ================================================================================================

window.YourNameTxtid = "Nama"; // Your Name -----------
window.YourNameTxten = "Your Name";
window.YourNameCannotEmptyTxtid = "Nama Tidak Boleh Kosong!";
window.YourNameCannotEmptyTxten = "Name cannot be Empty!";

window.FirstNameTxtid = "Nama depan"; // First Name -----------
window.FirstNameTxten = "First Name";
window.InputFirstNamePlaceholderid = "Masukkan Nama Depan";
window.InputFirstNamePlaceholderen = "Input First Name";
window.FirstNameCannotEmptyid = "Nama Depan Tidak Boleh Kosong!";
window.FirstNameCannotEmptyen = "First Name cannot be Empty!";

window.LastNameTxtid = "Nama Belakang"; // Last Name -----------
window.LastNameTxten = "Last Name";
window.InputLastNamePlaceholderid = "Masukkan Nama Belakang";
window.InputLastNamePlaceholderen = "Input Last Name";

window.FullNameTxtid = "Nama Lengkap"; // Full Name -----------
window.FullNameTxten = "Full Name";
window.InputFullNamePlaceholderTxtid = "Masukkan Nama Lengkap";
window.InputFullNamePlaceholderTxten = "Input Full Name";
window.FullNameCannotEmptyTxtid = "Nama Lengkap Tidak Boleh Kosong!";
window.FullNameCannotEmptyTxten = "Full Name cannot be Empty!";

window.GenderHeaderTxtid = "Jenis kelamin"; // Gender -----------
window.GenderHeaderTxten = "Gender";

window.GenderChoicesJSON =
[
    {
        "which_value":"Male",
        "which_type":["Male", "Laki-Laki"],
        "translation": 
        {
            "id":"Laki-Laki",
            "en":"Male"
        }
    },
    {
        "which_value":"Female",
        "which_type":["Female", "Perempuan"],
        "translation": 
        {
            "id":"Perempuan",
            "en":"Female"
        }
    },
];


window.PhoneNumberHeaderTxtid = "Nomor Telepon"; // Phone Number -----------
window.PhoneNumberHeaderTxten = "Phone Number";

window.PhoneNumberCannotEmptyid = "Nomor Telepon tidak Boleh Kosong!";
window.PhoneNumberCannotEmptyen = "Phone Number cannot be Empty!";

window.PhoneNumberAlreadyUsedTxtid = "Nomor Telepon Sudah Digunakan!";
window.PhoneNumberAlreadyUsedTxten = "Phone Number Already Used!";

window.PhoneNumberInvalidTxtid = "Nomor Telepon Tidak Valid!";
window.PhoneNumberInvalidTxten = "Phone Number Invalid!";

window.ThisPhonehasWATxtid = "Nomor telepon ini memiliki WhatsApp";
window.ThisPhonehasWATxten = "This phone number have WhatsApp";


window.CountryHeaderTxtid = "Negara"; // Country -----------
window.CountryHeaderTxten = "Country";


window.IDCardHeaderTxtid = "Nomor KTP"; // ID Card -----------
window.IDCardHeaderTxten = "ID Card";

window.IDCardInputPlaceholderid = "Masukkan Kartu Identitas Anda";
window.IDCardInputPlaceholderen = "Enter your ID Card";

window.IDCardCannotEmptyid = "Kartu Identitas Tidak Boleh Kosong!";
window.IDCardCannotEmptyen = "ID Card cannot be Empty!";

window.IDCardCannotBeUsedid = "Kartu Identitas tidak dapat digunakan!";
window.IDCardCannotBeUseden = "ID Card cannot be Used!";


window.IDCardPassportTxtid = "Nomor Identitas"; // ID Card/ Passport -----------
window.IDCardPassportTxten = "ID Card/ Passport";
window.IDCardPassportInputPlaceholderTxtid = "Misalnya: 12345678910";
window.IDCardPassportInputPlaceholderTxten = "e.g.: 12345678910";


window.ReferralIDid = "ID Referral"; // Referral -----------
window.ReferralIDen = "Referral ID";
window.ReferralIDInputPlaceholderid = "Masukkan Kode Referral Anda";
window.ReferralIDInputPlaceholderen = "Enter your Referral ID";


window.EmailTxtid = "E-mail"; // Email -----------
window.EmailTxten = "Email";

window.EmailAddressTxtid = "Alamat Email";
window.EmailAddressTxten = "Email Address";

window.SampleEmailPlaceholderid = "Misalnya: test@gmail.com";
window.SampleEmailPlaceholderen = "e.g.: test@gmail.com";

window.InputEmailPlaceholderid = "Masukkan Alamat Email Anda";
window.InputEmailPlaceholderen = "Input your Email Address";

window.EmailCannotEmptyTxtid = "E-mail Tidak Bisa Kosong!";
window.EmailCannotEmptyTxten = "Email cannot be Empty!";

window.InvalidEmailFormatMesid = "<span class='InterBoldTextFont'>Format Email salah</span>, cek Email anda atau coba lagi";
window.InvalidEmailFormatMesen = "Invalid Email Format!";

window.EmailAlreadyUsedid = "Email Sudah Digunakan!";
window.EmailAlreadyUseden = "Email Already Used!";


window.PasswordHeaderTextid = "Kata Sandi"; // Password -----------
window.PasswordHeaderTexten= "Password";
window.InputPassPlaceholderid = "Masukkan Kata Sandi Email Anda";
window.InputPassPlaceholderen = "Input your Email Password";
window.PasswordCannotBeEmptyTxtid = "Kata Sandi Tidak Boleh Kosong!";
window.PasswordCannotBeEmptyTxten = "Password cannot be Empty!";

window.NewPasswordPlaceholderTxtid = "Masukkan Kata Sandi Baru Anda";
window.NewPasswordPlaceholderTxten = "Input your New Password";
window.NewPasswordCannotBeEmptyid = "Kata Sandi Baru Tidak Boleh Kosong!";
window.NewPasswordCannotBeEmptyen = "New Password cannot be Empty!";

window.ReenterPasswordHeaderTextid = "Ulangi Password";
window.ReenterPasswordHeaderTexten= "Re-type Password";
window.ReenterPasswordPlaceholderTxtid = "Ketik ulang Kata Sandi yang Anda masukkan";
window.ReenterPasswordPlaceholderTxten = "Re-Type your inputted Password";

window.ConfirmPasswordEmptyTextid = "Konfirmasi Kata Sandi Tidak Boleh Kosong!";
window.ConfirmPasswordEmptyTexten = "Confirm Password cannot be Empty!";

window.ConfirmPasswordNotSameid = "Konfirmasi Kata Sandi harus sama dengan Kata Sandi Baru!";
window.ConfirmPasswordNotSameen = "Confirm Password must be same as New Password!";

window.MinPassWarningid = "Jumlah Karakter Minimal 6";
window.MinPassWarningen = "Minimum Number of Characters is 6";
window.PassNotStrongid = "Kata Sandi Tidak Cukup Kuat";
window.PassNotStrongen = "Password Not Stong Enough";

window.ForgotPasswordTxtid = "Lupa Kata Sandi";
window.ForgotPasswordTxten = "Forgot Password";

// --------------------------------------------------------------------

window.AccommodationNameSampleTxtid = "Misalnya: Luxury Glalmping";  // Accommodation Name -------------------------------------
window.AccommodationNameSampleTxten = "e.g. Luxury Glalmping";

window.AccommodationNameCannotEmptyTxtid = "Nama Akomodasi tidak boleh kosong";
window.AccommodationNameCannotEmptyTxten = "Accommodation Name cannot be empty";

window.OtherAccommodationCannotEmptyTxtid = "Tipe Akomodasi Lain Tidak Dapat Dikosongkan";
window.OtherAccommodationCannotEmptyTxten = "Other Accommodation Type Cannot Empty";


window.ProvinceTxtid = "Provinsi"; // Province -------------------------------------
window.ProvinceTxten = "Province";

window.ProvinceCannotEmptyTxtid = "Provinsi tidak boleh Kosong";
window.ProvinceCannotEmptyTxten = "Province cannot be empty";


window.CityRegionTxtid = "Wilayah Kota"; // City Region -------------------------------------
window.CityRegionTxten = "City Region";

window.CityRegionCannotEmptyTxtid = "City Region tidak boleh Kosong";
window.CityRegionCannotEmptyTxten = "City Region cannot be empty";


window.FullAddressTxtid = "Alamat Lengkap"; // Full Address -------------------------------------
window.FullAddressTxten = "Full Address";

window.FullAddressPlaceholderTxtid = "Masukkan alamat lengkap akomodasi";
window.FullAddressPlaceholderTxten = "Enter accommodation full address";

window.FullAddressCannotEmptyTxtid = "Alamat Lengkap tidak boleh Kosong";
window.FullAddressCannotEmptyTxten = "Full Address cannot be empty";


window.GoogleMapsUrlTxtid = "Tautan Google Maps"; // Google Maps -------------------------------------
window.GoogleMapsUrlTxten = "Google Maps Link";

window.GoogleMapPlaceholderTxtid = "Misalnya: https://maps.app.goo.gl/YP5jR5jGQrymsKWHA";
window.GoogleMapPlaceholderTxten = "eg. https://maps.app.goo.gl/YP5jR5jGQrymsKWHA";

window.GoogleMapsUrlCannotEmptyTxtid = "Tautan Google Maps tidak boleh Kosong";
window.GoogleMapsUrlCannotEmptyTxten = "Google Maps Link cannot be empty";


window.AccPhotosTxtid = "Foto Akomodasi"; // Accommodation --------------
window.AccPhotosTxten = "Accommodation Photos";

window.AddPhotoRuleAndLimitTxtid = "Tambahkan foto akomodasi Anda di sini, dan Anda dapat mengunggah maksimal 10 file dan minimal 1 foto";
window.AddPhotoRuleAndLimitTxten = "Add your accommodation photos here, and you can upload up to 10 files max and min 1 photo";

window.DragYourFileOrInputTxtid = "Seret file Anda atau <span style='color: #1849D6;' class='HyperlinkUnderlineText'>Telusuri</span>";
window.DragYourFileOrInputTxten = "Drag your file(s) or <span style='color: #1849D6;' class='HyperlinkUnderlineText'>Browse</span>";

window.Max10MBFilesAllowedTxtid = "Ukuran file yang diizinkan maksimal 10 MB";
window.Max10MBFilesAllowedTxten = "Max 10 MB files are allowed";

window.AccommodationPhotoCannotEmptyTxtid = "Foto Akomodasi tidak boleh Kosong";
window.AccommodationPhotoCannotEmptyTxten = "Accommodation Photos cannot be empty";


window.AccSocialMediaTxtid = "Media Sosial Akomodasi"; // Accommodation Media Social --------------
window.AccSocialMediaTxten = "Accommodation Social Media";

window.AddYourAccSocialMediaTxtid = "Tambahkan media sosial akomodasi Anda, baik tiktok atau instagram.";
window.AddYourAccSocialMediaTxten = "Add your accommodation social media, either tiktok or instagram.";


window.TotalRoomsTxtid = "Jumlah Kamar"; // Total Rooms -------------------------------------
window.TotalRoomsTxten = "Total Rooms";
window.TotalPlaceholderTxtid = "Masukkan jumlah kamar";
window.TotalPlaceholderTxten = "Enter total rooms";
window.TotalRoomsCannotEmptyTxtid = "Jumlah Kamar Tidak Boleh Kosong!";
window.TotalRoomsCannotEmptyTxten = "Total Rooms cannot be Empty!";

window.RoomRatesTxtid = "Tarif Kamar"; // Rooms Rates or Price -------------------------------------
window.RoomRatesTxten = "Room Rates";

window.MinRoomRatesCannotEmptyTxtid = "Harga Tarif Kamar Minimum tidak boleh kosong!";
window.MinRoomRatesCannotEmptyTxten = "Min Room Rates Price cannot be empty!";

window.ToTxtid = "sampai";
window.ToTxten = "to";

window.MaxRoomRatesCannotEmptyTxtid = "Harga Tarif Kamar Maksimum tidak boleh kosong!";
window.MaxRoomRatesCannotEmptyTxten = "Max Room Rates Price cannot be empty!";

window.MaxRoomRatesPricesCannotLowerTxtid = "Harga Tarif Kamar Maksimum tidak boleh lebih rendah dari Nilai Minimum!";
window.MaxRoomRatesPricesCannotLowerTxten = "Max Room Rates Price cannot be lower than the Min Value!";


window.DepartmentTxtid = "Departemen"; // Department -------------------------------------
window.DepartmentTxten = "Department";

window.DepartmentPlaceholderTxtid = "Misalnya: Pemilik, Manajer";
window.DepartmentPlaceholderTxten = "eg. Owner, Manager";

window.DepartmentCannotEmptyTxtid = "Departemen tidak boleh kosong!";
window.DepartmentCannotEmptyTxten = "Department cannot be empty!";


window.AccommodationSubmittedTxtid = "Akomodasi Berhasil Dikirim"; // Listing Done -------------------------------------
window.AccommodationSubmittedTxten = "Accommodation Submitted";

window.HelloThankyouForSubmittingAccTxtid = "Halo! Terima kasih telah mengirimkan data akomodasi Anda. Tim kami akan segera menghubungi Anda, dan akomodasi Anda akan segera tampil di platform kami.";
window.HelloThankyouForSubmittingAccTxten = "Hello! Thank you for submitting your accommodation. Our team will contact you shortly, and your accommodation will be listed on our platform soon.";

window.NowTxtid = "Sekarang"; // Now -------------------------------------
window.NowTxten = "Now";

// General Error ================================================================================================

window.URLFormatInvalidTxtid = "Format URL Tidak Valid!";
window.URLFormatInvalidTxten = "URL Format Invalid!";

// Social ================================================================================================

window.WhatsAppTxtid = "WhatsApp";
window.WhatsAppTxten = "WhatsApp";
window.WhatsAppNumberTxtid = "Nomor Whatsapp";
window.WhatsAppNumberTxten = "Whatsapp Number";
window.WhatsAppNumberEmptyTxtid = "Nomor WhatsApp tidak boleh kosong!";
window.WhatsAppNumberEmptyTxten = "WhatsApp Number cannot be empty!";

window.InstagramTxtid = "Instagram";
window.InstagramTxten = "Instagram";
window.InstagramEmptyTxtid = "Instagram Tidak Boleh Kosong!";
window.InstagramEmptyTxten = "Instagram cannot be empty!";
window.InstagramPlaceholderTxtid = "Misalnya: https://www.instagram.com/pingingo.official/";
window.InstagramPlaceholderTxten = "e.g. https://www.instagram.com/pingingo.official/";

window.TikTokTxtid = "TikTok";
window.TikTokTxten = "TikTok";
window.TikTokEmptyTxtid = "Link TikTok tidak boleh kosong!";
window.TikTokEmptyTxten = "TikTok Link cannot be empty!";
window.TikTokPlaceholderTxtid = "Misalnya: https://www.tiktok.com/@pingingo.official";
window.TikTokPlaceholderTxten = "e.g. https://www.tiktok.com/@pingingo.official";

window.FacebookTxtid = "Facebook";
window.FacebookTxten = "Facebook";

window.CrowdSharingTxtid = "Crowd Sharing";
window.CrowdSharingTxten = "Crowd Sharing";
window.CrowdSharing2Txtid = "Ping & Share (Crowd Sharing)";
window.CrowdSharing2Txten = "Ping & Share (Crowd Sharing)";

window.PopUpBannerTxtid = "PopUp Banner";
window.PopUpBannerTxten = "PopUp Banner";

window.EmailBlastTxtid = "Email Blast";
window.EmailBlastTxten = "Email Blast";

window.PinginGoBlogTxtid = "PinginGo Blog";
window.PinginGoBlogTxten = "PinginGo Blog";

window.BlogPinginGoTxtid = "Blog PinginGo";
window.BlogPinginGoTxten = "Blog PinginGo";

// COMMON BUTTONS OR BASIC UI ================================================================================================

window.HelpCenterTxtid = "Pusat Bantuan"; // Help Center 
window.HelpCenterTxten = "Help Center";

window.HelpTxtid = "Bantuan";
window.HelpTxten = "Help";

window.PropertyAuditFullTxtid = "Audit Properti Gratis 15 Menit"; // Property Audit 
window.PropertyAuditFullTxten = "Free 15-Minute Property Audit";

window.PropertyAuditTxtid = "Audit Properti";
window.PropertyAuditTxten = "Property Audit";

window.GabungSekarangTxtid = "Gabung Sekarang"; // Join Now 
window.GabungSekarangTxten = "Join Now";

window.GabungTxtid = "Gabung";
window.GabungTxten = "Join";

window.PinginGoTxtid = "PinginGo"; // PinginGo 
window.PinginGoTxten = "PinginGo";

window.SearchTxtid = "Cari Penginapan"; // Search 
window.SearchTxten = "Search";

window.ContinueTxtid = "Lanjutkan"; // Continue 
window.ContinueTxten= "Continue";

window.ContinueTxt2id = "Lanjut"; // Continue 2
window.ContinueTxt2en= "Continue";

window.CancelTxtid = "Batal"; // Cancel 
window.CancelTxten = "Cancel";

window.CloseButtonTxtid = "Tutup";
window.CloseButtonTxten = "Close";

window.BackTxtid = "Kembali"; // Back 
window.BackTxten= "Back";

window.SelesaiTxtid = "Selesai"; // Selesai 
window.SelesaiTxten= "Done";

window.SavedButtonTxtid = "Simpan"; // Save
window.SavedButtonTxten = "Save";

window.TukarRewardTxtid = "Tukar Reward"; // Tukar Rewards
window.TukarRewardTxten = "Exchange Rewards";

window.SetuplaterTextid = "Atur Nanti"; // Set Up Later 
window.SetuplaterTexten = "Set-Up Later";

window.ExplorePinginGoTextid = "Explore Sekarang"; // Explore PinginGo 
window.ExplorePinginGoTexten = "Explore PinginGo";

window.ListingYourAccBtnTextid = "Daftar Jadi Mitra Sekarang"; // List Your Acc -------------
window.ListingYourAccBtnTexten = "Listing your Accommodation";

window.ListingYourAccBtnTextSrtid = "Jadi Mitra"; // List Your Acc Short -------------
window.ListingYourAccBtnTextSrten = "Become a Partner";

window.LoginBtnTextid = "Masuk"; // Sign In 
window.LoginBtnTexten = "Sign In";

window.RegisterBtnTextid = "Daftar"; // Register 
window.RegisterBtnTexten = "Register";

window.ReadMoreBtnTextid = "Selengkapnya"; // Read More 
window.ReadMoreBtnTexten = "Read more";

window.ContinueWithEmailTxtid = "Lanjutkan dengan Email"; // Continue with Email 
window.ContinueWithEmailTxten = "Continue with Email";

window.ResendEmailBtnTxtid = "Kirim Ulang Email"; // Resend Email
window.ResendEmailBtnTxten = "Resend Email";

window.ChangeEmailBtnTxtid = "Ubah Alamat Email"; // Change Email
window.ChangeEmailBtnTxten = "Change Email Address";

window.CopyTxtid = "Salin";
window.CopyTxten = "Copy";

window.LoadMoreTxtid = "Lihat Lainnya";
window.LoadMoreTxten = "Load More";

window.SendMessageButtonTxtid = "Kirim Pesan";
window.SendMessageButtonTxten = "Send Message";

window.ChatOnWhatsAppButtonTxtid = "Kirim Pesan via WhatsApp";
window.ChatOnWhatsAppButtonTxten = "Chat on WhatsApp";

//???????????????
window.SignInwithPhoneTxtid = "Masuk dengan Nomor Telepon"; // Sign In Use Phone
window.SignInwithPhoneTxten = "Sign in with Phone";
//???????????????

window.NextBtnTxtid = "Berikutnya"; // Next
window.NextBtnTxten = "Next";

window.SeeMapTxtid = "Lihat Peta"; // See Map
window.SeeMapTxten = "See Map";

window.SelectRoomButtonTxtid = "Pilih Kamar";
window.SelectRoomButtonTxten = "Select Room";

window.SelectedButtonTxtid = "Dipilih";
window.SelectedButtonTxten = "Selected";

window.ChangeSettingsTxtid = "Ubah Tanggal";
window.ChangeSettingsTxten = "Change Settings";

window.ExpandBtnTxtid = "Perbesar";
window.ExpandBtnTxten = "Expand";

window.PingNowBtnTxtid = "Booking Sekarang";
window.PingNowBtnTxten = "Ping Now";

window.DapatkanRefMessageTxtid = "Dapatkan Referral Poin setelah teman kamu menginap";
window.DapatkanRefMessageTxten = "Earn Referral Points after your friend stays";

window.ShareThisPingTxtid = "Bagikan Booking";
window.ShareThisPingTxten = "Share this Ping";

window.ShareAccommodationTxtid = "Bagikan Penginapan";
window.ShareAccommodationTxten = "Share Accommodation";

window.SeeDetailsBtnTxtid = "Lihat Rincian";
window.SeeDetailsBtnTxten = "See Details";

window.VerifyBtnTxtid = "Verifikasi";
window.VerifyBtnTxten = "Verify";

window.ExploreTxtid = "Jelajahi";
window.ExploreTxten = "Explore";

window.RemovePhotoTxtid = "Hapus Foto";
window.RemovePhotoTxten = "Remove Photo";

window.AddPhotoToYourExperiencesButtonTxtid = "Tambahkan FotoTambahkan Foto ke Pengalamanmu 📸";
window.AddPhotoToYourExperiencesButtonTxten = "Add Photo to your experiences";

window.YouHaveFinishedStayingMessageTxtid = function(accname){ return "Anda telah selesai menginap di <a class='FontInter600'>"+ accname +"</a>, Anda dapat berbagi pengalaman dan aktivitas berkesan Anda di " + accname +" di sini";}
window.YouHaveFinishedStayingMessageTxten = function(accname){ return "You have finished staying at <a class='FontInter600'>"+ accname +"</a>, you can share your memorable experiences activities at " + accname +" here";}

window.SubmitExperienceButtonTxtid = "Bagikan Pengalaman";
window.SubmitExperienceButtonTxten = "Submit Experience";

window.CopyClipboardSuccessTxtid = "Teks Berhasil Disalin";
window.CopyClipboardSuccessTxten = "Copied to Clipboard Successfully";

window.ApplyTxtid = "Simpan";
window.ApplyTxten = "Apply";

window.ShareReferralTxtid = "Bagikan Kode Referral";
window.ShareReferralTxten = "Share Referral";


// ====================================== LANGUAGE ======================================

window.CurrentAvailableLang =
[
    {
        "LanguageName":"Bahasa Indonesia",
        "code":"id",
        "FlagIcon":"/Assets/images/CountryCode/Indonesia.svg",
    },
    {
        "LanguageName":"English",
        "code":"en",
        "FlagIcon":"/Assets/images/CountryCode/UnitedKingdom.svg",
    }
]